import type { CancelablePromise } from "../client"
import { OpenAPI } from "../client"
import { request as __request } from "../client/core/request"

export type ProductFileDTO = {
  id: string
  item_id: string
  file_name: string
  size_bytes: number
  mime: string
  download_url: string
  created_at: string
}

export const ProductFilesService = {
  listProductFiles: (
    productId: string,
  ): CancelablePromise<ProductFileDTO[]> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/products/{id}/files",
      path: { id: productId },
    })
  },

  uploadProductFiles: (
    productId: string,
    files: File[],
  ): CancelablePromise<ProductFileDTO[]> => {
    return __request(OpenAPI, {
      method: "POST",
      url: "/v1/products/{id}/files",
      path: { id: productId },
      formData: { files },
      mediaType: "multipart/form-data",
    })
  },

  deleteProductFile: (
    productId: string,
    fileId: string,
  ): CancelablePromise<void> => {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/v1/products/{id}/files/{fileId}",
      path: { id: productId, fileId },
    })
  },
}
